<script setup lang="ts">
import type { IBlogPost } from '~/server/api/blog/types';
const route = useRoute();

const { t } = useI18n();

useHead(() => ({
  title: t('BLOG'),
}))

const { data } = await useAsyncData(
  'blog_posts', 
  () => getPosts(),  
  {
    watch: [route]
  }
);

function getPosts () {
  let path = '/api/blog/posts';

  const queries = [];

  if (route.query.category) {
    queries.push(`category=${route.query.category}`);
  }

  if (route.query.title) {
    queries.push(`title=${route.query.title}`);
  }

  if (route.query.page) {
    queries.push(`page=${route.query.page}`);
  }

  if (queries.length) {
    path += `?${queries.join('&')}`;
  }

  return $fetch<IBlogPost>(path);
}

</script>

<template>
  <main class="inline-block h-full">
    <header class="text-center mt-28 block mb-24 flex-col">
      <span class="text-4xl md:text-6xl font-bold" v-if="!route.query.title">
        {{ $t(route.query.category ? 'BLOG_FILTER' : 'BLOG', { desc: route.query.category_n }) }}
      </span>

      <span class="text-6xl font-bold" v-if="route.query.title">
        {{ $t('SEARCHING_BY', { title: route.query.title }) }}
      </span>

      <div class="block my-6">
        <nuxt-link to="/" class="hover:underline" v-if="!route.query.category && !route.query.title">
          {{ $t('HOME') }}
        </nuxt-link>

        <nuxt-link to="/blog" class="hover:underline" v-if="route.query.category || route.query.title">
          {{ $t('BACK_TO_BLOG') }}
        </nuxt-link>
        -
        <span>
          {{ $t('ALL_POSTS') }}
        </span>
      </div>
    </header>

    <article class="flex flex-col xl:flex-row justify-between py-8 mx-auto max-w-container-ws gap-8 items-start">
      <div class="order-2 xl:order-1">
        <ul class="" v-if="data?.totalDocs">
          <BlogCardList
            v-for="post in data.docs"
            :key="post.id"
            :description="post.excerpt"
            :date="post.createdAt"
            :title="post.title"
            :cover="post.featuredImage?.url"
            :slug="post.slug"
          />
        </ul>
        <span class="text-2xl italic px-4" v-else>
          {{ $t('NO_POSTS_FOUND') }}
        </span>
        <BlogPagination
          v-if="data"
          :current-page="data.page"
          :total-pages="data.totalDocs"
          :on-change="() => console.info('Teste')"
          :start-page="1"
          >
        </BlogPagination>
      </div>
      <BlogFilter class="order-1 xl:order-2"/>
    </article>
  </main>
</template>
<style lang="scss" scoped>
swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  height: 20vh;
  width: 100%;
  font-size: 4rem;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
}

swiper-container {
  width: 100%;
}

main {
  background-color: #fff;

  ul {
    li:not(:last-child) {
      margin-bottom: 32px;
    }
  }
}

article div:first-child {
  width: 100%;
  max-width: 1120px;
}
</style>